import React from 'react';
import { Image } from 'antd';
import * as MaterialProgramTip from '../materialPrograms/MaterialProgramTip';
import * as Tooltip from '../Tooltip';
import { TooltipStyles } from '../Tooltip.styles';
import { DivFlexWithWrap, DivImpactArea, DivImpactAreaImage, DivImpactAreaName, DtGroup, DtOtherGroup, DtCmfContainer, DtCmfImage, DtBlock, DtRow, DtName, DtLink, IaLegend } from './DtImpactAreasTip.styles';

const DtImpactAreasTip: React.FC = ( data: any, dtImpactAreas: Array<any> ) => {
    const dts = dtImpactAreas.length && dtImpactAreas.length > 0 ? dtImpactAreas : data.dtImpactAreas;
    const dtsSustainability = dts.filter((dt) => dt.groupName === 'Sustainability' || dt.groupName === 'Other' || dt.groupName === 'Leed' || dt.groupName === 'Leed LEM')
    .sort(
      (dt1, dt2) => dt1.name.localeCompare(dt2.name)
    );

    const getInspectAreaImage = (impactAreaName : string) => {
       switch(impactAreaName) {
          case 'HUMAN HEALTH':
              return 'src/assets/images/health_red_notext.svg';
          case 'CLIMATE HEALTH':
              return 'src/assets/images/climate_blue_notext.svg';
          case 'CIRCULAR ECONOMY':
              return 'src/assets/images/circularity_blue_notext.svg';
          case 'SOCIAL HEALTH & EQUITY':
              return 'src/assets/images/social_purple_notext.svg';
          case 'ECOSYSTEM HEALTH':
              return 'src/assets/images/ecosystem_green_notext.svg';
          default:
            return '';
       }
    };

    const allImpactAreas = ['Human Health','Climate Health','Circular Economy','Social Health & Equity','Ecosystem Health'];

    return (
        <MaterialProgramTip.Container spanset={true}>
            <Tooltip.Container spanset={true}>
                <TooltipStyles className='program-cmfdt shadow'>
                    <div className='tooltip-cmf tooltip-cmfdt'>

         {dtsSustainability.length > 0 && (
          <DtGroup>
            <p><b>Documents uploaded for this product</b></p>
              {dtsSustainability?.map((dt, i) => (
                <DtBlock key={i}>
                   <DtRow height={dt.name.length > 40 ? 28 : 14}>
                     <DtName>
                         <DtLink href={dt.url}>
                             {dt.name}
                         </DtLink>
                     </DtName>

                     <DtCmfContainer>
                        {dt?.impactAreas?.map((impactArea) => (
                          <>
                            {impactArea.name && (
                              <DtCmfImage>
                                 <Image
                                    preview={false}
                                    src={getInspectAreaImage(impactArea.name?.toUpperCase())}
                                    style={{ cursor: 'pointer' }}
                                    title={impactArea.name}
                                    width={14} height={14}
                                 />
                              </DtCmfImage>
                            )}
                          </>
                        ))}
                     </DtCmfContainer>
                   </DtRow>
                </DtBlock>
              ))}
          </DtGroup>
        )}

          <IaLegend>
            <p><b>mindful MATERIALS Common Materials Framework</b></p>
              <DivFlexWithWrap>
                {allImpactAreas?.map((impactArea) => (
                  <DivImpactArea key={impactArea?.toUpperCase()}>
                    <DivImpactAreaImage>
                       <Image
                         preview={false}
                         src={getInspectAreaImage(impactArea?.toUpperCase())}
                         style={{ cursor: 'none' }}
                         width={22} height={22}
                       />
                    </DivImpactAreaImage>
                    <DivImpactAreaName>
                       {impactArea}
                    </DivImpactAreaName>
                  </DivImpactArea>
                ))}
              </DivFlexWithWrap>
          </IaLegend>

                    </div>
                </TooltipStyles>
            </Tooltip.Container>
        </MaterialProgramTip.Container>
    );
};

export default DtImpactAreasTip;
